export default {
    pohodnistvo: ['nadmorska-visina', 'cas-vzpona', 'visinska-razlika'],
    kultura: ['nadmorska-visina', 'vstopnina', 'dostopnost'],
    'naravne-lepote': ['nadmorska-visina', 'dostopnost', 'gostinska-ponudba'],
    'poletna-osvezitev': ['nadmorska-visina', 'aktivnosti', 'dostopnost'],
    raziskovanje: ['nadmorska-visina', 'dostopnost', 'vstopnina'],
    feratanje: ['visinska-razlika', 'tezavnost-ferate', 'cas-plezanja'],
    supanje: ['nadmorska-visina', 'dostop-do-vode', 'izposoja-opreme']
};
